<template>
	<div id="cale">
		<!-- BEGIN calendar -->
		<FullCalendar ref="calendar" :options="calendarOptions"></FullCalendar>
		<!-- END calendar -->
	</div>
</template>

<style scoped lang="less">
/deep/ .acitavedate {
	background: #e3bebe !important;
}

/deep/ .fc-daygrid-event-harness {
	margin: 0.2rem 0;
}
</style>

<script>
import '@fullcalendar/core/vdom'; // solves problem with Vite
import FullCalendar from '@fullcalendar/vue';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import listPlugin from '@fullcalendar/list';
import bootstrapPlugin from '@fullcalendar/bootstrap';
import $ from 'jquery';

export default {
	components: {
		FullCalendar // make the <FullCalendar> tag available
	},
	props: {
		oknumlist: Array,
		powerlist: Array
	},

	data() {
		return {
			calendarOptions: {
				allDayText: '全天',
				locale: 'zh-cn', // 中文

				plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin, listPlugin, bootstrapPlugin],
				headerToolbar: {
					left: 'dayGridMonth,timeGridWeek,timeGridDay',
					center: 'title',
					right: 'prevMonthCustom,nextMonthCustom todayCustom'
				},
				buttonText: {
					today: '本月',
					month: '月视图',
					week: '周视图',
					day: '日期视图'
				},
				initialView: 'dayGridMonth',
				height: 'auto',
				editable: false,
				droppable: true,
				themeSystem: 'bootstrap',
				views: {
					timeGrid: {
						eventLimit: 6 // adjust to 6 only for timeGridWeek/timeGridDay
					}
				},
				events: [],
				//这个事件是  点击插件里面的单条数据时触发
				eventClick: this.handleEventClick,
				//这个事件是 当你点击日期单元格时触发
				dateClick: this.handleDateClick,
				// 自定义按钮
				customButtons: {
					prevMonthCustom: {
						text: '上月',
						click: this.prevMonthCustomClick
					},
					nextMonthCustom: {
						text: '下月',
						click: this.nextMonthCustomClick
					},
					todayCustom: {
						text: '今天',
						click: this.todayCustomClick
					}
				}
			},
			oknumlists: [],
			powerlists: [],
			calendarApi: {},
			// 日期选中
			currentYear: new Date().getFullYear(),
			currentMonth: new Date().getMonth() + 1,
			datelist: this.getMonthDate()
		};
	},
	watch: {
		oknumlist(val) {
			this.oknumlists = val;
			// console.log(val,"获取")
			this.setcalendarOptions();
		},
		powerlist(val) {
			this.powerlists = val;
			// console.log(val, "获取list")
			this.setcalendarOptions();
		}
	},
	beforeMount() {},
	mounted() {
		this.setcalendarOptions();
		this.calendarApi = this.$refs.calendar.getApi(); //一旦你有ref，你可以通过getApi方法得到底层的日历对象:
	},
	methods: {
		// 上月点击
		prevMonthCustomClick() {
			this.calendarApi.prev(); // 调用next方法
			let test = this.calendarApi.getCurrentData().currentDate;
			// console.log(new Date(test).getMonth() + 1, "上月点击")
			this.currentYear = new Date(test).getFullYear();
			this.currentMonth = new Date(test).getMonth() + 1;
			this.datelist = this.getMonthDate(new Date(test));
			this.setcalendarOptions();
		},
		// 下月点击
		nextMonthCustomClick() {
			this.calendarApi.next(); // 调用next方法
			let test = this.calendarApi.getCurrentData().currentDate;
			// console.log(new Date(test).getMonth() + 1, "下月点击")
			this.currentYear = new Date(test).getFullYear();
			this.currentMonth = new Date(test).getMonth() + 1;
			this.datelist = this.getMonthDate(new Date(test));

			this.setcalendarOptions();
		},
		// 今日点击
		todayCustomClick() {
			// FullCalendar.today();
			this.calendarApi.today();
			let test = this.calendarApi.getCurrentData().currentDate;
			this.currentYear = new Date().getFullYear();
			this.currentMonth = new Date().getMonth() + 1;
			this.datelist = this.getMonthDate(new Date(test));
			this.setcalendarOptions();
		},

		// 点击日程触发
		handleEventClick(data) {
			// console.log(data.event)
		},

		// 点击日期触发事假
		handleDateClick(data1) {
			// console.log(data1,"日期选择")
			$(data1.dayEl)
				.parents('table')
				.contents()
				.eq(1)
				.find('td')
				.removeClass('acitavedate');
			$(data1.dayEl).addClass('acitavedate');
			this.$parent.$parent.$parent.getclassstadentlist(data1.dateStr);
		},

		setcalendarOptions() {
			let eventslist = [];
			// console.log(this.powerlists, "获取预约记录")
			var newArr = this.oknumlist.map(Number);
			var testArr = newArr;
			var datelist = this.getMonthDate();
		
			// console.log('月份所有天数', datelist);
			var date = new Date();
			var currentYear = date.getFullYear();
			var currentMonth = date.getMonth() + 1;
			currentMonth = currentMonth < 10 ? '0' + currentMonth : currentMonth;

			// 根据oknumlist判断预约周
			datelist.forEach((item, index) => {
				let entimes = parseInt(item.slice(-2)) + 1;
				entimes = entimes < 10 ? '0' + entimes : entimes;
				let strattime = this.currentYear + '-' + this.currentMonth + '-' + item.slice(-2);
				let entime = this.currentYear + '-' + this.currentMonth + '-' + entimes;
				// console.log(strattime)
				// console.log(entime)
				if (testArr.indexOf(this.getWeek(item)) >= 0) {
					// console.log("下一步锁死")
					let eventobj = {
						title: '可预约',
						start: strattime,
						end: entime,
						color: '#24ac1a'
					};
					eventslist.push(eventobj);
					// console.log("可约")
				} else {
					let eventobj1 = {
						title: '不可预约',
						start: strattime,
						end: entime,
						color: '#9f9f9f'
					};
					eventslist.push(eventobj1);
				}
			});

			// 后台返回数据判断预约人数与开放人数
			this.powerlists.forEach(item => {
				// console.log(item.ap_appDate.slice(0, 8), "字符串截取")
				let endnums = Number(item.ap_appDate.slice(-2)) + 1;
				// console.log(item.ap_appDate.slice(0, 8) + endnums, "字符串截取")
				let poweryobj = {
					title: '开放人数' + item.BookingNo + ' 预约' + '   ' + item.HaveBookingNo,
					start: item.ap_appDate,
					end: item.ap_appDate.slice(0, 8) + endnums,
					color: '#FB5597'
				};
				eventslist.push(poweryobj);

				let poweryobjs = {
					title: '待审核' + item.ApprovalNo,
					start: item.ap_appDate,
					end: item.ap_appDate.slice(0, 8) + endnums,
					color: '#dada00'
				};
				eventslist.push(poweryobjs);

				let poweryobjs1 = {
					title: '已取消' + item.CancelledNo,
					start: item.ap_appDate,
					end: item.ap_appDate.slice(0, 8) + endnums,
					color: '#a2a2a2'
				};

				let poweryobjs2 = {
					title: '审核通过：\t' + item.PassedNo,
					start: item.ap_appDate,
					end: item.ap_appDate.slice(0, 8) + endnums,
					color: '#48d800'
				};

				let poweryobjs3 = {
					title: '已驳回：\t' + item.RejectedNo,
					start: item.ap_appDate,
					end: item.ap_appDate.slice(0, 8) + endnums,
					color: '#ff4400'
				};

				eventslist.push(poweryobjs1);
				eventslist.push(poweryobjs2);
				eventslist.push(poweryobjs3);
			});

			// console.log(eventslist, "总预约数据")
			this.calendarOptions.events = eventslist;
		},

		getWeek(day) {
			// console.log(day)
			var daymouth = [7, 1, 2, 3, 4, 5, 6];
			var weeknum = new Date(day).getDay();
			var weekmouth = daymouth[weeknum];
			// console.log(weekmouth)
			return weekmouth;
		},
		// 获取月份所有的天数组成数组
		getMonthDate(date) {
			let nowdays = date ? new Date(date) : new Date();

			let year = nowdays.getFullYear();
			let month = nowdays.getMonth() + 1;
			if (month < 10) {
				month = '0' + month;
			}
			let myDate = new Date(year, month, 0);
			// console.log(myDate.getDate());
			let tempList = [];
			for (let i = 1; i <= myDate.getDate(); i++) {
				if (i < 10) {
					tempList.push(year + '-' + month + '-' + '0' + i);
				} else {
					tempList.push(year + '-' + month + '-' + i);
				}
			}
			// console.log("天数列表",tempList)
			return tempList;
		}
	}
};
</script>
